import React, { useState, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_Rooms_Images } from '../../../../../constants/APIs';
import ImageGallery from '../gallery/index'
import Validation from '../../../../../components/Validation';
import IntlMessages from '../../../../../helpers/IntlMessages';

export const RoomImage = ({ visible, toggle, images, roomId }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [roomImages, setRoomImages] = useState(images || [{ caption: '', url: '', priority: '', videoUrl: '' }]);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [imageIndex, setImageIndex] = useState(-1);
  const handleChange = (e, index) => {
    e.persist();
    const newItems = [...roomImages];
    newItems[index][e.target.name] = e.target.value;
    setRoomImages(newItems);
  };

  const deleteImage = (index) => {
    let newImages = roomImages.length > 1 ? roomImages.filter((item, j) => (index !== j)) : roomImages;
    setRoomImages(newImages);
  };

  const addImage = () => {
    setRoomImages(roomImages.concat({ caption: '', url: '', priority: '1', videoUrl: '' }));
  };

  const togglegallery = (index) => {
    setImageIndex(index)
    setGalleryVisible(!galleryVisible);
  };

  const selectedImage = (image) => {
    const newItems = [...roomImages];
    newItems[imageIndex].url = image.src;
    newItems[imageIndex].caption = image.caption;
    setRoomImages(newItems);
  };

  const handleRoomImage = async () => {
    let data = { id: roomId, images: roomImages, updater: 'Test123' };
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Update_Rooms_Images}/${roomId}`,
      data: data,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
      }
      else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    })
      .catch(err => {
        console.log('err', err);
      });
  }
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={galleryVisible} toggle={togglegallery} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery selectedImage={selectedImage} togglegallery={togglegallery}
                    hideUserUploads={false} searchText={""} />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
        <ModalHeader toggle={toggle}>
          Room Images
        </ModalHeader>
        <ModalBody>
          <Row>
            {roomImages.length > 0 && roomImages.map((image, index) => (
              <Fragment key={index}>
                <Colxx sm={2} className="md-3">
                  <img
                    style={{
                      width: '100%',
                      height: '90%',
                    }}
                    alt="room image"
                    src={image.url || 'https://via.placeholder.com/150/'}
                  />
                </Colxx>
                <Colxx sm={2} className="mb-3">
                  <Label>Caption</Label>
                  <Input
                    type="text"
                    name="caption"
                    value={image.caption}
                    onChange={event => handleChange(event, index)}
                  />
                </Colxx>

                <Colxx sm={2} className="mb-3">
                  <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
                  <Input
                    type="number"
                    name="priority"
                    min={1}
                    value={image.priority}
                    onChange={event => handleChange(event, index)}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Video Link</Label>
                  <Input
                    type="text"
                    name="videoUrl"
                    value={image.videoUrl}
                    onChange={event => handleChange(event, index)}
                  />
                </Colxx>
                <Colxx sm={1} className="mb-3">
                  <Label>Browse</Label>
                  <div className="iconsminds-photo" onClick={event => togglegallery(index)}
                    style={{ cursor: 'pointer', fontSize: '28px', color: '#73236b' }}
                  >

                  </div>
                </Colxx>
                <Colxx sm={1} className="mb-3">
                  <Label>Remove</Label>
                  <div>
                    <Button
                      onClick={() => deleteImage(index)}
                      color="secondary"
                      size="xs"
                      outline
                      style={{ margin: '6px' }}
                    >
                      -
                    </Button>
                  </div>
                </Colxx>
              </Fragment>
            ))}
          </Row>
          <Button
            onClick={addImage}
            color="primary"
            size="xs"
            outline
            style={{ margin: '6px' }}
          >
            + <IntlMessages id='dashboards.addImages' />
          </Button>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleRoomImage}>
            <IntlMessages id='dashboards.save' />
          </Button>
          <Button color="secondary" onClick={toggle}>
            <IntlMessages id='pages.cancel' />
          </Button>
        </ModalFooter>
      </Modal>
      {ImageGalleryButton()}
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
};
const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(RoomImage));